import { Component } from "preact";
import { connect } from "react-redux";
import { change, Field, formValueSelector, reduxForm } from "redux-form";
import Page from "../../../components/Page";
import ActionBar from "../../../components/ActionBar";
import ActionButton from "../../../components/ActionButton";
import Content from "../../../components/Content";
import InputField from "../../../components/fields/InputField";
import Smile from "../../../assets/images/logos/faces/simle";
import RadioField from "../../../components/fields/RadioField";
import config from "../../../config";
import { getEventPublic } from "../../../state/actions/eventActions";
import {
  getOrderPublic,
  saveOrderData,
  saveOrderPublic
} from "../../../state/actions/orderActions";
import { setToken } from "../../../state/actions/attendeeProfileActions";
import { setSeatingMapRequired } from "../../../state/actions/seatingMapActions";
import { scrollToErrors } from "../../../utils/ScrollToErrors";
import { email, required } from "../../../utils/Validators";
import OrderQuestions from "../../details/OrderQuestions";
import TicketsQuestions from "../../details/TicketsQuestions";
import AssignTickets from "../../conferences/AssignTickets";
import Header from "./Header";
import Steps from "./Steps";
import { getTicketValues } from "../../../utils/stateConstructors";
import { css } from "emotion";
const formName = "details";

const pageStyle = css({
  position: "relative",
  maxWidth: 1040,
  margin: "0px auto",
  background: "#fff",
  boxShadow: "0 1px 3px 0 rgba(9,30,66,0.13), 0 0 1px 0 #F1F1F1",
  borderTop: "none"
});

class OrderDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      saved: false
    };
  }
  componentWillMount() {
    const {
      getEventPublic,
      getOrderPublic,
      orderId,
      eventId,
      token,
      setToken
    } = this.props;
    getEventPublic(eventId, orderId, token);
    getOrderPublic(eventId, orderId, token);
    setToken(token);
  }

  componentDidUpdate(perviousProps) {
    const { order } = this.props;
    const isBrowser = typeof window !== "undefined";
    if (
      order.detailsRequest.saved &&
      !perviousProps.order.detailsRequest.saved
    ) {
      if (isBrowser) {
        window.scroll(0, 0);
      }
    }
  }

  save = data => {
    const { saveOrderPublic, orderId, eventId, token, event } = this.props;
    const orderAdditionalFields = [];
    for (var key in data.order.additionalFields) {
      orderAdditionalFields.push({
        questionId: key,
        value: data.order.additionalFields[key]
      });
    }
    const tickets = [];
    let additionalFields = [];
    for (var key in data.tickets) {
      const ticket = data.tickets[key];
      for (var addQId in ticket) {
        additionalFields.push({
          questionId: addQId,
          value: ticket[addQId]
        });
      }
      tickets.push({
        _id: key,
        additionalFields
      });
      additionalFields = [];
    }
    const orderData = {
      ...data.order,
      additionalFields: orderAdditionalFields,
      tickets
    };
    saveOrderPublic(eventId, orderId, token, orderData);
    const isConference = event.data.settings.enableTicketAssigning;
    if (isConference) {
      this.setState({
        page: 1
      });
    }
  };

  render({
    order,
    event,
    ticketsAdditionalQuestions,
    sameAsBuyerChecks,
    buyerData,
    token
  }) {
    const isConference =
      event && event.data && event.data.settings.enableTicketAssigning;
    const { page } = this.state;
    const orderLoaded = order.data && !order.loading;
    const eventLoaded = event.data && !event.loading;
    if (!orderLoaded || !eventLoaded) {
      return null;
    }
    return (
      <div
        style={{
          background: "#F9F9FA", //this.getBackground(event, theme, background),
          backgroundSize: "cover", ///backgroundSize,
          paddingBottom: 12,
          padding: 7
        }}
      >
        <div style={{ maxWidth: 1040, margin: "0px auto" }}>
          <Header />
        </div>
        {order.detailsRequest.saved ? (
          <div style={{ textAlign: "center" }}>
            <h2>Order Updated</h2>
            <Smile style={{ width: 200, marginBottom: 12 }} />
          </div>
        ) : null}

        <h2 style={{ maxWidth: 1040, margin: "0px auto" }}>{`Edit Order: ${
          order.data.orderName
        }`}</h2>

        <div className={pageStyle}>
          {isConference ? (
            <div>
              <Steps page={page} />
            </div>
          ) : null}
          <Content style={{ padding: "20px 24px", marginTop: 28 }}>
            {page === 1 ? (
              <AssignTickets orderId={order.data._id} />
            ) : (
              <OrderDetailsForm
                saveDetails={this.save}
                order={order}
                event={event}
                {...{
                  ticketsAdditionalQuestions,
                  sameAsBuyerChecks,
                  buyerData
                }}
              />
            )}
          </Content>
        </div>
      </div>
    );
  }
}

let OrderDetailsForm = ({
  event,
  order,
  handleSubmit,
  saveDetails,
  orderAdditionalQuestions,
  businessPurpose,
  dispatch,
  isGlobal,
  ticketsAdditionalQuestions,
  sameAsBuyerChecks,
  buyerData
}) => {
  const changeFieldValue = (field, value) => {
    dispatch(change(formName, field, value));
  };

  let mobileRequired = event.data.settings.mobileRequired !== false;

  const isConference = event.data.settings.enableTicketAssigning;
  const businessPurposeOptions = [
    {
      label: "Individual",
      value: "false"
    },
    {
      label: "Business",
      value: "true"
    }
  ];
  const businessTaxIdName = config("TAX_NAME") || "Tax ID";
  let detailsAdditionQuestions =
    !isGlobal &&
    event.data.additionalQuestions &&
    event.data.additionalQuestions.length
      ? event.data.additionalQuestions.filter(q => !q.askAfterCheckout)
      : [];
  detailsAdditionQuestions = detailsAdditionQuestions.map(q => {
    if (q.type === "multiSelect" && q.options && q.options.length) {
      q.options = q.options.map(o => {
        const newOption = o.label
          ? {
              ...o
            }
          : {
              ...o,
              id: o._id,
              label: o.value,
              value: false
            };
        return newOption;
      });
    }
    return q;
  });
  return (
    <div>
      <form onSubmit={handleSubmit(saveDetails)}>
        <div
          style={
            order.timeExpired
              ? {
                  pointerEvents: "none"
                }
              : {}
          }
        >
          <div
            style={{
              marginBottom: 24
            }}
          >
            {order.detailsRequest.error ? (
              <div>
                {order.detailsRequest.additionalQuestionQuantityError ? (
                  <div>
                    <p class="text-error">
                      Some selections are no longer available
                    </p>
                    {order.detailsRequest.error.message.map(msg => {
                      return <p class="text-error">{msg}</p>;
                    })}
                  </div>
                ) : (
                  <p class="text-error">{order.detailsRequest.error.message}</p>
                )}
              </div>
            ) : (
              ""
            )}

            <h3 class="sub-header">Buyer Information</h3>
            <Field
              label="First Name"
              type="text"
              name="order.firstName"
              component={InputField}
              required={true}
              validate={required}
              autocomplete="given-name"
            />
            <Field
              label="Last Name"
              type="text"
              name="order.lastName"
              component={InputField}
              required={true}
              validate={required}
              autocomplete="family-name"
            />

            <Field
              label="Email"
              type="text"
              name="order.email"
              component={InputField}
              required={true}
              validate={[required, email]}
              autocomplete="email"
            />
            <Field
              label="Mobile"
              type="text"
              name="order.mobile"
              component={InputField}
              required={mobileRequired}
              validate={mobileRequired ? required : null}
              autocomplete="tel"
            />

            {!isGlobal && !event.data.settings.hideIsBusinessQuestion ? (
              <Field
                label="Is your purchase for business purposes?"
                name="order.businessPurpose"
                component={RadioField}
                defaultValue={"false"}
                inline={true}
                options={businessPurposeOptions}
                validate={required}
              />
            ) : null}

            {businessPurpose === "true" && (
              <div
                style={{
                  background: "#FAFAF9",
                  padding: 12
                }}
              >
                <Field
                  label={businessTaxIdName}
                  type="text"
                  name="order.businessTaxId"
                  component={InputField}
                  validate={required}
                />
                <Field
                  label="Business Name"
                  type="text"
                  name="order.businessName"
                  component={InputField}
                  validate={required}
                />
              </div>
            )}

            <OrderQuestions
              additionalQuestions={detailsAdditionQuestions}
              orderAdditionalQuestions={orderAdditionalQuestions}
              changeFieldValue={changeFieldValue}
              tickets={order.data.tickets}
            />
            {!isConference ? (
              <TicketsQuestions
                tickets={order.data.tickets}
                ticketTypes={event.data.ticketTypes}
                ticketsAdditionalQuestions={ticketsAdditionalQuestions}
                additionalQuestions={detailsAdditionQuestions}
                buyerData={buyerData}
                changeFieldValue={changeFieldValue}
                sameAsBuyerChecks={sameAsBuyerChecks}
              />
            ) : null}
          </div>
        </div>

        <ActionBar>
          <ActionButton
            disabled={
              order.detailsRequest.loading ||
              order.timeExpired ||
              order.addDiscountRequest.loading
            }
            loading={
              order.detailsRequest.loading || order.addDiscountRequest.loading
            }
            dataCY="save"
          >
            {isConference ? "Save and continue" : "Save"}
          </ActionButton>
        </ActionBar>
      </form>
    </div>
  );
};

OrderDetailsForm = reduxForm({
  form: formName,
  destroyOnUnmount: false,
  onSubmitFail: errors => {
    scrollToErrors();
  }
})(OrderDetailsForm);

function getOrderValues(
  order,
  providedOrderData,
  additionalQuestions,
  formOrder
) {
  if (formOrder) {
    return formOrder;
  }

  if (order.businessPurpose === false || !order.businessPurpose) {
    order.businessPurpose = "false";
  }
  if (order && order.additionalFields) {
    const mappedOrder = {
      ...order
    };
    mappedOrder.additionalFields = {};
    if (order.additionalFields && order.additionalFields.length > 0) {
      order.additionalFields.forEach(field => {
        mappedOrder.additionalFields[field.questionId] = field.value;
      });
    } else if (additionalQuestions && additionalQuestions.length > 0) {
      additionalQuestions.forEach(question => {
        question.defaultValue && question.perOrder && !question.askAfterCheckout
          ? (mappedOrder.additionalFields[question._id] = question.defaultValue)
          : "";
      });
    }
    return mappedOrder;
  }

  return order;
}

const selector = formValueSelector(formName);

OrderDetailsForm = connect(
  (state, ownProps) => {
    const { isGlobal } = ownProps;
    const order = getOrderValues(
      state.order.data,
      state.order.providedOrderData,
      isGlobal ? [] : state.event.data.additionalQuestions,
      selector(state, "order")
    );

    const tickets = getTicketValues(
      state.order.data,
      state.event.data.additionalQuestions,
      selector(state, "tickets")
    );
    const initialValues = {
      order,
      tickets
    };

    return {
      initialValues: initialValues,
      event: state.event,
      order: state.order
    };
  },
  {}
)(OrderDetailsForm);

export default connect(
  (state, ownProps) => {
    return {
      event: state.event,
      order: state.order,
      seatingMap: state.seatingMap,
      merchandise: state.merchandise,
      giftCards: state.giftCards,
      ticketSelection: state.ticketSelection,
      buyerData: {
        firstName: selector(state, "order.firstName"),
        lastName: selector(state, "order.lastName"),
        mobile: selector(state, "order.mobile"),
        email: selector(state, "order.email")
      },
      businessPurpose: selector(state, "order.businessPurpose"),
      businessTaxId: selector(state, "order.businessTaxId"),
      businessName: selector(state, "order.businessName"),
      orderAdditionalQuestions: selector(state, "order.additionalFields"),
      ticketsAdditionalQuestions: selector(state, "tickets"),
      sameAsBuyerChecks: selector(state, "sameAsBuyerChecks")
    };
  },
  {
    saveOrderData,
    getEventPublic,
    getOrderPublic,
    setSeatingMapRequired,
    saveOrderPublic,
    setToken
  }
)(OrderDetails);



// WEBPACK FOOTER //
// ./routes/public/editOrder/PublicOrderDetails.js